__webpack_require__.p = "https://ui.prod.us-west-2.urc.advertising.amazon.dev/";